var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReceipt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M3.5 0A1.5 1.5 0 0 0 2 1.5v28.617a1.5 1.5 0 0 0 2.272 1.286l3.666-2.2 3.162 2.372a1.5 1.5 0 0 0 1.8 0L16 29.25l3.1 2.325a1.5 1.5 0 0 0 1.8 0l3.162-2.372 3.666 2.2A1.5 1.5 0 0 0 30 30.117V1.5A1.5 1.5 0 0 0 28.5 0zM4 29.234V2h24v27.234l-3.197-1.919a1.5 1.5 0 0 0-1.672.087L20 29.75l-3.1-2.325a1.5 1.5 0 0 0-1.8 0L12 29.75l-3.131-2.348a1.5 1.5 0 0 0-1.672-.087zM7.5 5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM7 13h10v2H7zm8 4H7v2h8zm-8 4h10v2H7zm18-8h-4v2h4zm-4 4h4v2h-4zm4 4h-4v2h4z",
  clipRule: "evenodd"
})));
export default SvgReceipt;